// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  APP_URL: 'https://api.staging.ufp.ai',
  BASE_URL: 'https://api.staging.ufp.ai',
  REPORT_URL: 'https://report-api.staging.ufp.ai',
  PAYOUT_ENGINE_URL: 'https://payout-api.staging.ufp.ai',
  RETAIL_BILLING_URL: 'https://retail-api.staging.ufp.ai',
  domain_suffix: 'fitnessforcenxt.com',
  Ip_Api_URL: "https://pro.ip-api.com/json/?key=MAkQGoxG3ZmGnth",
  googleGTM:"GTM-WQZTW6V", // Only for testing ...
  GOOGLE_PLACES: "AIzaSyClUgcDQ4nTHOVf1FtF-qeHA_tSpZRZRZA",
  GOOGLE_MAPS_MAP_ID: "e80bda931fcaef931e19e0da",
  hj:"3014151",//Hotjar Tracking Code (Site ID)
  IPinfoURL:"https://ipinfo.io/",
  IPinfoToken:"93aa1df60f63d9",
  PAYENGINE_PUBLIC_KEY:"pk_test_AHJBZxLeCo4slzEjh1gjkzb2lUL4TMli",
  GOOGLE_AUTH_ID:"1043119188769-ho5usgd60hmaibh81sqr2bf4vhhqrr6g.apps.googleusercontent.com",
  APPLE_ID:"com.unifiedfitnessplatform.staffWebappAppleAuth",
  MICROSOFT_CLIENT_ID:"2a5ff31b-c361-446c-973c-9560f71fec4e",
  CALLBACK_URL:"https://login.staff.staging.ufp.ai/auth/login/social-login.html",
  MICROSOFT_AUTHORITY:"https://login.microsoftonline.com/common/oauth2/v2.0/authorize",
  VI_URL:"https://af.vi-engage.com/iframe?group=fitnessforce",
  // REMOVE this is of development
  STATSIG_SDK_KEY:"client-A2YeCnbPXy1vc0P41UdfpRXANCflT3V7hvZhaUss0eB",
  ENVIRONMENT_NAME:"staging",
  LOGIN_DOMAIN:"https://login.staff.staging.ufp.ai",
  PUSHER_INSTANCE_ID:"e9786767-404a-49a9-831b-34affd9de3de",
  // ─── Stripo Plugin v2 ──────────────────────────────────────────────────────
  STRIPO_ENABLED: true,
  STRIPO_TOKEN_URL: '/email-builder/auth-token',
  STRIPO_PLUGIN_ID: '6b67a633668949d6b96381d33c3e0e86',
  /** Enable mini-search v2 for class / appointment member pickers (staging QA). */
  miniSearchV2: true,
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.


